/**
 * Kolumny tabeli sprzętu w ofercie — JEDNO źródło prawdy dla podglądu w panelu.
 *
 * Podgląd w konstruktorze oferty (`pages/OfferTemplate.js`) jest lustrem generatora PDF, czyli
 * `Login/backend/lib/offerHtml.js`, i wierność jest jego jedynym zadaniem. Dopóki nagłówki były
 * wpisane wprost w JSX, dało się je rozjechać jednym słowem i nikt tego nie zauważał aż do
 * pierwszej wysłanej oferty: podgląd pokazywał „Rodzaj", „szt.", „dni", „łącznie", a dokument
 * u klienta „Rodzaj sprzętu", „Ilość sztuk", „liczba dni", „cena łączna".
 *
 * Podgląd renderuje się TERAZ Z TEJ LISTY, a `Login/backend/tests/offerTableColumns.test.js`
 * porównuje ją z nagłówkami, które backend NAPRAWDĘ wypisuje (uruchamiając generator, nie
 * czytając jego kodu). Zmiana nagłówka po jednej stronie zapala ten test.
 */
export const OFFER_TABLE_COLUMNS = [
  { label: 'l.p.', width: '5%' },
  { label: 'Rodzaj sprzętu', width: '15%' },
  { label: 'klasa', width: '12%' },
  { label: 'marka', width: '13%' },
  { label: 'rozmiar', width: '10%' },
  { label: 'Ilość sztuk', width: '8%' },
  { label: 'cena/dzień', width: '11%' },
  { label: 'liczba dni', width: '8%' },
  { label: 'cena łączna', width: '11%' },
];

/**
 * Wyrównanie komórek wierszy tabeli sprzętu, kolumna po kolumnie (test odbiorczy 11.10.2026).
 * Lustro atrybutów `style="text-align:…"` w wierszach `lib/offerHtml.js` (komórka bez stylu =
 * „left”): kartka centrowała wszystkie komórki, a PDF trzyma rodzaj i markę przy lewej, kwoty
 * przy prawej. `Login/backend/tests/offerTableColumns.test.js` porównuje tę listę z wynikiem
 * generatora.
 */
export const OFFER_TABLE_CELL_ALIGN = ['center', 'left', 'center', 'left', 'center', 'center', 'right', 'center', 'right'];
